// Helper Component for Service Items
const ServiceItem = ({ text, iconColor }) => (
  <li className="flex items-center gap-3 text-slate-700 font-medium">
    <span
      className={`w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center text-sm ${iconColor}`}
    >
      ✓
    </span>
    {text}
  </li>
);

const ReBrandingSection = () => {
  return (
    <section className="py-24 bg-slate-50 text-slate-900 overflow-hidden">
      <div className="container mx-auto px-6 max-w-screen-xl">
        <div className="flex flex-col md:flex-row items-center gap-16">
          {/* --- Right Side: Text Content --- */}
          <div className="md:w-1/2">
            <span className="inline-block py-1 px-3 rounded-full bg-pink-100 text-blue-600 text-xs font-bold uppercase tracking-widest mb-4">
              Identity & Strategy
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Rebranding That <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-500">
                Defines Your Future
              </span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              A logo is just the beginning. We build complete visual identities
              that tell your story, evoke emotion, and set you apart from the
              competition.
            </p>

            {/* List of Services */}
            <ul className="space-y-4">
              <ServiceItem
                text="Professional Logo Redesign"
                iconColor="text-blue-500"
              />
              <ServiceItem
                text="Color Palette & Typography System"
                iconColor="text-blue-500"
              />
              <ServiceItem
                text="Brand Guidelines (Brand Book)"
                iconColor="text-blue-500"
              />
              <ServiceItem
                text="Stationery (Cards, Letterheads)"
                iconColor="text-blue-500"
              />
            </ul>

            <button className="mt-10 px-8 py-3 bg-slate-900 text-white font-semibold rounded-lg hover:bg-blue-600 transition-all duration-300 shadow-lg">
              Get Your Brand Kit
            </button>
          </div>

          {/* --- Left Side: Visual Mockup (Pure CSS) --- */}
          <div className="md:w-1/2 relative w-full flex justify-center">
            {/* Decorative Elements behind the main card */}
            <div className="absolute top-10 left-10 w-24 h-24 bg-pink-200 rounded-full blur-xl opacity-60"></div>
            <div className="absolute bottom-10 right-10 w-32 h-32 bg-rose-200 rounded-full blur-xl opacity-60"></div>

            {/* Main Card: Simulating a Brand Presentation */}
            <div className="relative bg-white p-8 rounded-3xl shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500 w-full max-w-md border border-slate-100">
              {/* Mock Brand Logo Area */}
              <div className="w-20 h-20 bg-gradient-to-tr from-pink-500 to-orange-400 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <span className="text-white text-3xl font-bold">A</span>
              </div>

              {/* Mock Color Palette */}
              <div className="flex gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-slate-900 border-2 border-white shadow-sm"></div>
                <div className="w-10 h-10 rounded-full bg-pink-500 border-2 border-white shadow-sm"></div>
                <div className="w-10 h-10 rounded-full bg-rose-300 border-2 border-white shadow-sm"></div>
              </div>

              {/* Mock Typography Lines */}
              <div className="h-4 bg-slate-100 rounded w-3/4 mb-3"></div>
              <div className="h-4 bg-slate-100 rounded w-1/2 mb-6"></div>

              {/* Mock Business Card (Inside the card) */}
              <div className="bg-slate-900 text-white p-4 rounded-xl relative overflow-hidden">
                <div className="absolute top-0 right-0 w-16 h-16 bg-pink-500 rounded-bl-full opacity-50"></div>
                <div className="w-8 h-8 bg-white/20 rounded mb-2"></div>
                <div className="h-2 bg-white/40 rounded w-1/2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReBrandingSection;
